function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import ParagraphComponent from "/components/core/paragraph/paragraph-component";
import SignupFormComponent from "components/core/signups/base-signup-form/signup-form-component";
import { StyledSimpleColorfulTitleWithSignupComponent } from "./simple-colorful-title-with-signup-component.scss";
class SimpleColorfulTitleWithSignupComponent extends PureComponent {
    render() {
        const { title, subtitle, signupForm, showDecorations, showSignup, isFirstSegment } = this.props;
        return /*#__PURE__*/ _jsxs(StyledSimpleColorfulTitleWithSignupComponent, {
            className: "simple-colorful-title-with-signup-component",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "title-wrapper",
                    children: /*#__PURE__*/ _jsx(ParagraphComponent, {
                        title: title,
                        isFirstSegment: isFirstSegment
                    })
                }),
                subtitle && /*#__PURE__*/ _jsx("div", {
                    className: "subtitle-wrapper",
                    children: typeof subtitle === "function" ? subtitle() : /*#__PURE__*/ _jsx("h2", {
                        dangerouslySetInnerHTML: {
                            __html: subtitle
                        }
                    })
                }),
                showSignup && /*#__PURE__*/ _jsx("div", {
                    className: "signup-form-with-decorations-wrapper",
                    children: /*#__PURE__*/ _jsx(SignupFormComponent, _object_spread_props(_object_spread({}, signupForm), {
                        showDecorations: showDecorations
                    }))
                })
            ]
        });
    }
}
export { SimpleColorfulTitleWithSignupComponent as default };
SimpleColorfulTitleWithSignupComponent.defaultProps = {
    title: "Start celebrating success. <brand-blue>Try for free</end>.",
    showSignup: true,
    isFirstSegment: false
};
